import { useContext } from 'react';
import { ForceRenderContext } from '../../providers/ForceRenderProvider';

export default function useForceRender() {
  return useContext(ForceRenderContext);
}
